import { Grid } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { Typography } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import api from "../API/api";
import { WHState } from "../Atom/AtomState";
import AlertComponent from "../CommonComponent/Alert/AlertComponent";
import BarCharts from "../CommonComponent/Charts/BarCharts";
import ButtonComponent from "../CommonComponent/Inputs/ButtonComponent";
import Loading from "../CommonComponent/LoadingBar/Loading";
import "../CSS/PageCSS/FitConsultResultPage.css";

const { Title } = Typography;

export default function FitConsultResultPage() {
  let navigate = useNavigate();
  const WH = useRecoilValue(WHState);
  const [fitTypeData, setFitTypeData] = useState<any>([]);
  const [faceTypeData, setFaceTypeData] = useState<any>([]);
  const [divboxHeight, setdivBoxHeight] = useState<number>(0);
  const [value, setValue] = useState<Dayjs>(dayjs());
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSearch = () => {
    const getData = async () => {
      setLoading(true);
      const fittype = await api.get(
        `/Result/getFitTypeResult?yyyy=${value.format("YYYY")}`
      );
      const facetype = await api.get(
        `/Result/getFaceTypeResult?yyyy=${value.format("YYYY")}`
      );
      setLoading(false);
      if (fittype != undefined && facetype != undefined) {
        setFitTypeData(fittype);
        setFaceTypeData(facetype);
      } else {
        setAlert(true);
        setAlertMessage("데이터 조회에 실패하였습니다.");
      }
    };
    getData();
  };

  useEffect(() => {
    const getData = async () => {
      setLoading(true);
      const fittype = await api.get(
        `/Result/getFitTypeResult?yyyy=${value.format("YYYY")}`
      );
      const facetype = await api.get(
        `/Result/getFaceTypeResult?yyyy=${value.format("YYYY")}`
      );
      setLoading(false);
      if (fittype != undefined && facetype != undefined) {
        setFitTypeData(fittype);
        setFaceTypeData(facetype);
      } else {
        setAlert(true);
        setAlertMessage("데이터 조회에 실패하였습니다.");
      }
    };
    getData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const div = document.getElementById("divbox") as HTMLElement;
      const FitConsultResultSearchTextDiv = document.getElementById(
        "FitConsultResultSearchTextDiv"
      ) as HTMLElement;
      if (div && FitConsultResultSearchTextDiv) {
        setdivBoxHeight(
          div.clientHeight - FitConsultResultSearchTextDiv.clientHeight - 20
        );
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return (
    <div style={{ height: WH.height - 160 }}>
      <Title level={2} className="FitConsultResultTitle">
        FitConsultResultPage
      </Title>
      <div id="divbox">
        <div
          className="FitConsultResultSearchTextDiv"
          id="FitConsultResultSearchTextDiv"
        >
          <DatePicker
            label="통계년도"
            value={value}
            onChange={(newValue: any) => setValue(newValue)}
            openTo="year"
            views={["year"]}
            format="YYYY"
            className="ColorYearSearch"
          />
          <ButtonComponent
            fullWidth
            variant="contained"
            className="FitConsultsearchTextDiv_searchButton"
            onClick={handleSearch}
          >
            검색
          </ButtonComponent>
        </div>
        <div style={{ height: divboxHeight }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 6 }}>
              <div className="ChartWrapper">
                <Title level={4} className="FitConsultResultTitle">
                  얼굴타입
                </Title>
                <BarCharts
                  columnlabel={faceTypeData.map((item: any) => item.name)}
                  data={[faceTypeData.map((item: any) => item.count)]}
                  label={["인원"]}
                />
              </div>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 6 }}>
              <div className="ChartWrapper">
                <Title level={4} className="FitConsultResultTitle">
                  체형타입
                </Title>
                <BarCharts
                  columnlabel={fitTypeData.map((item: any) => item.name)}
                  data={[fitTypeData.map((item: any) => item.count)]}
                  label={["인원"]}
                />
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
      {alert && (
        <AlertComponent value={alert} setValue={setAlert} info="error">
          {alertMessage}
        </AlertComponent>
      )}
      {loading && <Loading />}
    </div>
  );
}
